import {defineStore} from 'pinia'

export const useSharedStore = defineStore('shared', {
  state: () => ({
    isLoading: true,
    isDrawerOpen: false,
    topPadding: 0,
    bottomPadding: 0,
  }),
  getters: {
    getIsLoading(state): boolean {
      return state.isLoading;
    },
    getIsDrawerOpen(state): boolean {
      return state.isDrawerOpen;
    },
    getInset(state): { topPadding: string; bottomPadding: string; } {
      return {
        topPadding: state.topPadding + 'px',
        bottomPadding: state.bottomPadding + 'px',
      };
    },
  },
  actions: {
    setIsLoading(value: boolean) {
      this.isLoading = value;
    },
    setIsDrawerOpen(value: boolean) {
      this.isDrawerOpen = value;
    },
    setInsets(topPadding: number, bottomPadding: number) {
      this.topPadding = topPadding;
      this.bottomPadding = bottomPadding;
      console.log(`Insets: top: ${this.topPadding}, bottom: ${this.bottomPadding}`)
    }
  }
})
